import { useUtils as useI18nUtils } from '@core/libs/i18n'
// import { useUtils as useAclUtils } from '@core/libs/acl'

const { t } = useI18nUtils()
// const { canViewVerticalNavMenuHeader } = useAclUtils()

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
    const span = h(
      'span',
      {
        style: {
          backgroundColor: this.item.backgroundColor || '#f0f0f0', // default light gray
          color: this.item.color || 'black',
          padding: '0.5rem 1rem',
          display: 'block', // Changed to block to apply background color to total span length
          borderRadius: '4px',
          marginLeft: '5%',
          marginTop: '1rem',
          width: '90%', // Adjust width to span the desired length
        },
      },
      t(this.item.header),
    )
    const icon = h('feather-icon', {
      props: { icon: 'MoreHorizontalIcon', size: '18' },
      style: { marginLeft: '0.5rem' },
    })
    return h('li', {
      class: 'navigation-header d-flex align-items-center',
      style: {
        margin: '0.5rem 0',
      },
    }, [span, icon])
  },
}
